import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=faf24c70&scoped=true&"
import script from "./CheckboxInput.vue?vue&type=script&lang=js&"
export * from "./CheckboxInput.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=faf24c70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf24c70",
  null
  
)

export default component.exports